import { ReactNode, useEffect, useState } from 'react';
import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

enum EVisibleSlides {
    desktop = 4,
    sDesktop = 3,
    laptop = 2,
}

interface IProps {
    children: ReactNode[],
    mobileSlideWidth: number,
    desktopSlideWidth: number,
}

const TariffLineCarousel = styled(({ children, desktopSlideWidth, mobileSlideWidth, ...props }: IProps) => {
    const [hideArrows, setHideArrows] = useState(false);
    const [slideWidth, setSlideWidth] = useState(`${desktopSlideWidth}px`);
    const [slideIndex, setSlideIndex] = useState(0);

    const isDesktop = useMatchMediaByWidth(wideBreakpoints.sDesktop, true);
    const isSDesktop = useMatchMediaByWidth(wideBreakpoints.sDesktop);
    const isLaptop = useMatchMediaByWidth(wideBreakpoints.laptop);
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    useEffect(() => {
        setSlideIndex(0);

        if (isMobile) {
            setSlideWidth(`${mobileSlideWidth}px`);
            setHideArrows(true);
        } else {
            setSlideWidth(`${desktopSlideWidth}px`);

            if ((isLaptop && children.length > EVisibleSlides.laptop) ||
                (isSDesktop && children.length > EVisibleSlides.sDesktop) ||
                (isDesktop && children.length > EVisibleSlides.desktop)) {
                setHideArrows(false);
            } else {
                setHideArrows(true);
            }
        }
    }, [isDesktop, isSDesktop, isLaptop, isMobile, desktopSlideWidth, mobileSlideWidth]);

    return (
        <NukaCarousel
            slideIndex={slideIndex}
            afterSlide={setSlideIndex}
            withoutDots
            withoutArrows={hideArrows}
            framePadding={'0 0 8px'}
            slideWidth={slideWidth}
            cellSpacing={16}
            slidesToScroll={'auto'}
            disableEdgeSwiping={true}
            easing={'easeCubicOut'}
            edgeEasing={'easeCubicOut'}
            {...props}
        >
            {children}
        </NukaCarousel>
    );
})`
    padding-left: 0 !important;
    padding-right: 0 !important;

    & section,
    & div {
        outline: none;
    }

    & > section > div.slider-frame {
        padding: 24px 0 !important;
    }
`;

TariffLineCarousel.displayName = 'TariffLineCarousel';

export { TariffLineCarousel };
